import { render, staticRenderFns } from "./ManageWindow.vue?vue&type=template&id=b2fd8480"
import script from "./ManageWindow.vue?vue&type=script&lang=js"
export * from "./ManageWindow.vue?vue&type=script&lang=js"
import style0 from "./ManageWindow.vue?vue&type=style&index=0&id=b2fd8480&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports